import React, { Component } from 'react';

const ProviderStaffChanges = () => {
	return ( <h1>Provider Staff Changes</h1> );
}
 
export default ProviderStaffChanges;